export const getSSOProvider = (cognitoUsername, tenantName) => {
  if (cognitoUsername) {
    if (cognitoUsername.toLowerCase().includes('google')) {
      return 'Google';
    }
    if (cognitoUsername.toLowerCase().includes('facebook')) {
      return 'Facebook';
    }
    if (cognitoUsername.toLowerCase().includes(tenantName.toLowerCase())) {
      return tenantName;
    }
    return false;
  }
  return 'noCog';
};
